(() => {
  const CONFIG = window.MM_VARIANT_CONFIG || {};

  function getCfgForSection(sectionId) {
    return CONFIG && sectionId && CONFIG[sectionId] ? CONFIG[sectionId] : null;
  }

  function getRoot(sectionId) {
    return document.querySelector(`product-info[data-section="${sectionId}"]`) || null;
  }

  function getForms(root) {
    return Array.from(root.querySelectorAll('form[action^="/cart/add"]'));
  }

  function setATCState(root, enabled) {
    getForms(root).forEach((form) => {
      form.querySelectorAll('button[name="add"]').forEach((btn) => {
        btn.disabled = !enabled;
        if (!enabled) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
      });
    });

    root.querySelectorAll('.shopify-payment-button__button').forEach((btn) => {
      btn.disabled = !enabled;
      btn.style.pointerEvents = enabled ? '' : 'none';
      btn.style.opacity = enabled ? '' : '0.5';
    });
  }

  function clearVariantId(root) {
    getForms(root).forEach((form) => {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = '';
    });
  }

  function anyOptionSelected(root) {
    if (root.querySelector('input[type="radio"][name]:checked')) return true;

    const selects = root.querySelectorAll('select[name]');
    for (const s of selects) {
      if (s.value && s.value.trim() !== '') return true;
    }
    return false;
  }

  function clearAllOptionInputs(root) {
    root.querySelectorAll('input[type="radio"][name]').forEach((el) => {
      el.checked = false;
      el.removeAttribute('checked');
    });
    root.querySelectorAll('select[name]').forEach((sel) => {
      sel.selectedIndex = -1;
      sel.value = '';
    });
  }

  function hasVariantInUrl() {
    return new URL(window.location.href).searchParams.has('variant');
  }

  function initSection(sectionId) {
    const cfg = getCfgForSection(sectionId);
    if (!cfg || !cfg.noPreselect) return;

    const root = getRoot(sectionId);
    if (!root) return;

    const isWorkshop = root.dataset.mmIsWorkshop === 'true';
if (!isWorkshop) return;


    if (hasVariantInUrl()) return;

    let userInteracted = false;

    const forceReset = () => {
      if (userInteracted) return;
      clearAllOptionInputs(root);
      clearVariantId(root);
      setATCState(root, false);
    };

    forceReset();
    setTimeout(forceReset, 0);
    setTimeout(forceReset, 50);
    setTimeout(forceReset, 250);
    setTimeout(forceReset, 800);

    root.addEventListener(
      'change',
      (e) => {
        const t = e.target;
        if (!(t instanceof HTMLElement)) return;
        if (!t.matches('input[type="radio"][name], select[name]')) return;

        userInteracted = true;

        setTimeout(() => {
          const selected = anyOptionSelected(root);
          setATCState(root, selected);
          if (!selected) clearVariantId(root);
        }, 0);
      },
      { passive: true }
    );
  }

  function boot() {
    Object.keys(CONFIG).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e.detail?.sectionId;
    if (sectionId) initSection(sectionId);
  });
})();
